import React from 'react';
import PropTypes from 'prop-types';
import { generateShareIcon, ShareButtons } from 'react-share';
import cx from 'classnames';
import * as styles from './ShareFacebookButton.scss';

const FacebookIcon = generateShareIcon('facebook');

const iconProperties = {
  round: true,
  size: 32,
  iconBgStyle: {
    fill: 'transparent'
  }
};

const { FacebookShareButton } = ShareButtons;

const ShareFacebookButton = (props) => {
  const { sharingUrl } = props.sharingData || {};
  const { title, handleClick } = props;
  const onShareWindowClose = props.onShareWindowClose || (() => {});

  return (
    <div className={cx(styles.shareButton, props.className)} onClick={handleClick}>
      <FacebookShareButton
        url={sharingUrl}
        onShareWindowClose={onShareWindowClose}
      >
        <span>{title}</span>
        <FacebookIcon className={styles.fbIcon} {...iconProperties} />
      </FacebookShareButton>
    </div>
  );
};

ShareFacebookButton.propTypes = {
  sharingData: PropTypes.object,
  title: PropTypes.string,
  handleClick: PropTypes.func,
  onShareWindowClose: PropTypes.func,
  className: PropTypes.string
};

export default ShareFacebookButton;
